/* TheStudiz – scroll arrows (‹ ›) for horizontal rows: upsell, recently viewed. Computer par mouse se side-scroll nahi hota. */
document.addEventListener('click', function (e) {
  var btn = e.target.closest && e.target.closest('[data-scroll-prev],[data-scroll-next]');
  if (!btn) return;
  var wrap = btn.closest('[data-scroll-wrap]');
  var row = wrap && wrap.querySelector('[data-scroll-row]');
  if (!row) return;
  var dir = btn.hasAttribute('data-scroll-next') ? 1 : -1;
  row.scrollBy({ left: dir * Math.max(row.clientWidth * 0.8, 140), behavior: 'smooth' });
});
function updateScrollArrows(row) {
  var wrap = row.closest('[data-scroll-wrap]');
  if (!wrap || wrap.hasAttribute('data-hero')) return;
  var prev = wrap.querySelector('[data-scroll-prev]');
  var next = wrap.querySelector('[data-scroll-next]');
  if (prev) prev.disabled = row.scrollLeft <= 2;
  if (next) next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
}
document.addEventListener('scroll', function (e) {
  var t = e.target;
  if (t && t.matches && t.matches('[data-scroll-row]')) updateScrollArrows(t);
}, true);
